import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { LedgerEntry, LedgerEntryCreate, LedgerEntryFilter } from '../data/ledgerEntry';

export function createLedgerEntryService(client: AxiosInstance) {
  return createCrudService<LedgerEntry, LedgerEntryCreate, LedgerEntryFilter>(
    client,
    '/LedgerEntry',
    'ledgerEntryId'
  );
}

export type LedgerEntryService = CrudService<LedgerEntry, LedgerEntryCreate, LedgerEntryFilter>;
